import { v4 as uuidv4 } from "uuid";

export const transformData = (data, logo) => {
  var resultArray;

  if (data !== undefined || data !== null) {
    const politicianArray = data.map((obj) => {
      return {
        id: obj._id,
        type: obj.party,
        image: obj.image,
        name: obj.name,
        fail: false,
        complete: false,
        image_class: "person",
      };
    });

    const logoExists = (type) => {
      return logo.some((el) => {
        return el.type === type;
      });
    };

    let partiLogoArray = politicianArray.map((x) => {
      let tempPartiLogoArray;
      if (!logoExists(x.type)) {
        tempPartiLogoArray = {
          id: uuidv4(),
          type: x.type,
          name: x.type,
          image: "",
          fail: false,
          complete: false,
        };
      } else {
        const item = logo.find((item) => item.type === x.type);

        tempPartiLogoArray = {
          id: item._id + uuidv4(),
          type: item.type,
          name: item.name,
          image: item.image,
          fail: false,
          complete: false,
        };
      }
      return tempPartiLogoArray;
    });

    resultArray = politicianArray.concat(partiLogoArray);
  }

  return resultArray;
};
